export default rangeSlider => {
    if ($('.rangeslider').length < 1) {
        return false;
    }

    let $rangeSlider = $('.rangeslider');

    $rangeSlider.each((key, item) => {
        let $item = $(item);
        let $label = $item.prev();
        let $activeStart = $item.find('input:checked');

        $activeStart.prevAll().addClass('is-active');

        $item.append(
            $('<span>').addClass('change-selector')
        );

        $item.find('input[type=radio]').each((index, input) => {
            let $input = $(input);

            $('<span class="check"></span>').insertAfter($input);
        });

        if ($label.find('.state').length < 1) {
            $label.append(
                $('<span>').addClass('state').text($item.find('input:checked').next().next().text())
            );
        }

        let count = $activeStart.parent().find('input.is-active').length;

        $item.append(
            $('<input>').attr('type', 'range').addClass('rangeslider-appearance').attr('max', $item.find('input:not([type=range])').length-1).attr('min', '0').attr('step', '1').val(count)
        );
    });

    $rangeSlider.find('input').on('change', event => {
        let $active = $(event.currentTarget);
        let $slider = $active.parent();
        let $state = $slider.prev().find('.state');

        $active.addClass('is-active');

        $active.nextAll().removeClass('is-active');
        $active.prevAll().addClass('is-active');

        return $state.text($active.next().next().text());
    });

    let $slider = $('input[type=range]');

    $slider.on('input change', event => {
        let $item = $(event.currentTarget);
        let $parent = $item.parent();
        let $inputs = $parent.find('input');

        $($inputs[$item.val()]).prop('checked', 'checked').trigger('change');
    });
};
